import {
  createTheme as createStyled,
  responsiveFontSizes,
} from '@mui/material/styles';
import type { Theme, ThemeOptions } from '@mui/material';
import { THEMES } from '../constants';
import { lightShadows, darkShadows } from './shadows';
import { metbusDark, metbusLight } from './metbus';
import { esES } from '@mui/material/locale';
import { SizeType } from 'src/contexts/SettingsContext';

interface ThemeConfig {
  theme?: string;
  fontSize?: SizeType;
}

const baseOptions: ThemeOptions = {
  direction: 'ltr',
  components: {
    MuiAvatar: {
      styleOverrides: {
        fallback: {
          height: '75%',
          width: '75%',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: {
          variant: 'h6',
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 3,
          overflow: 'hidden',
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 'auto',
          marginRight: '16px',
        },
      },
    },
  },
  typography: {
    fontFamily: `Arial`,
    fontSize: 14,
  },
};

const themesOptions: Record<string, ThemeOptions> = {
  [THEMES.METBUSLIGHT]: {
    shadows: lightShadows,
    ...metbusLight,
  },
  [THEMES.METBUSDARK]: {
    shadows: darkShadows,
    ...metbusDark,
  },
};

export const createTheme = (config: ThemeConfig): Theme => {
  const themeOptions = themesOptions[config.theme ?? THEMES.METBUSLIGHT];

  // Construir typography combinando base, config.typography y fontSize
  let typography = {
    ...baseOptions.typography,
  };
  // fontSize defaults to 14
  // if config.fontSize is 'small' set fontSize to 8
  // if config.fontSize is 'large' set fontSize to 20
  // if config.fontSize is 'medium' set fontSize to 14
  if (config.fontSize) {
    typography = {
      ...typography,
      fontSize:
        config.fontSize === 'small' ? 8 : config.fontSize === 'large' ? 20 : 14,
    };
  }

  const options: ThemeOptions = {
    ...baseOptions,
    ...themeOptions,
    typography,
  };

  let theme = createStyled(options, esES);
  theme = responsiveFontSizes(theme);

  return theme;
};
